import React, { useEffect, useState } from "react";

export function useCountUp(target, duration = 1000) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const from = 0;
    const to = Number(target) || 0;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(from + (to - from) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return val;
}

export function StatCard({ icon: Icon, label, value, suffix = "", accent = "navy", testid }) {
  const count = useCountUp(value);
  const tones = {
    navy: { chip: "bg-navy/10 text-navy", card: "border-navy/15 bg-navy/[0.04]" },
    green: { chip: "bg-emerald-100 text-emerald-700", card: "border-emerald-100 bg-emerald-50/60" },
    gold: { chip: "bg-amber-100 text-amber-700", card: "border-amber-100 bg-amber-50/70" },
    blue: { chip: "bg-sky-100 text-sky-700", card: "border-sky-100 bg-sky-50/60" },
    red: { chip: "bg-rose-100 text-rose-600", card: "border-rose-100 bg-rose-50/60" },
    purple: { chip: "bg-violet-100 text-violet-700", card: "border-violet-100 bg-violet-50/60" },
  };
  const t = tones[accent] || tones.navy;
  return (
    <div data-testid={testid} className={`card-hover rounded-2xl border p-6 soft-shadow ${t.card}`}>
      <div className="flex items-center justify-between">
        <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${t.chip}`}>
          {Icon && <Icon className="h-6 w-6" />}
        </div>
      </div>
      <p className="mt-4 font-heading text-3xl font-extrabold text-navy">
        {count}
        {suffix && <span className="text-lg text-slate-400"> {suffix}</span>}
      </p>
      <p className="mt-1 text-sm text-slate-500">{label}</p>
    </div>
  );
}
